<template>
  <base-dialog-prompt
    :model-value="isOpen"
    @update:model-value="setOpen"
  >
    <template #title>
      {{ prompt }}
    </template>
    <template v-if="$slots.default" #content>
      <slot></slot>
    </template>
    <template #actions>
      <v-btn
        :color="confirmColor"
        variant="flat"
        class="text-white"
        @click="confirm()"
      >{{ confirmText }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :color="cancelColor || undefined"
        @click="cancel()"
      >{{ cancelText }}</v-btn>
    </template>
  </base-dialog-prompt>
</template>

<script>
export default {
  name: 'BaseDialogConfirmation',

  inheritAttrs: false,

  props: {
    modelValue: {},
    value: {},
    prompt: {
      type: String,
      default: 'Do you really want to proceed?',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmColor: {
      type: String,
      default: 'red',
    },
    cancelColor: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue', 'input', 'confirm', 'cancel'],

  computed: {
    isOpen() {
      return !!(this.modelValue ?? this.value);
    },
  },

  methods: {
    setOpen(open) {
      const value = open ? (this.modelValue ?? this.value ?? true) : false;
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },

    confirm() {
      this.$emit('confirm');
      this.setOpen(false);
    },

    cancel() {
      this.$emit('cancel');
      this.setOpen(false);
    },
  },
};
</script>
